interface CategoryState {
  name: string;
  fullPath: string;
  filledPath: string;
}

export class SortOrderTracker {
  private nextSortOrder: { [key: number]: number };
  private categoryToSortOrder: { [key: number]: { [key: string]: number } };
  private seenCategories: { [key: number]: Set<string> };

  constructor() {
    // Initialize starting sort orders for each level
    this.nextSortOrder = {
      0: 10000,
      1: 10000,
      2: 10000,
      3: 10000,
      4: 10000
    };

    // Initialize mapping of categories to their sort orders for each level
    this.categoryToSortOrder = {
      0: {},
      1: {},
      2: {},
      3: {},
      4: {}
    };

    // Initialize sets to track seen categories at each level
    this.seenCategories = {
      0: new Set<string>(),
      1: new Set<string>(),
      2: new Set<string>(),
      3: new Set<string>(),
      4: new Set<string>()
    };
  }

  updateSortOrders(
    level: number,
    categoryName: string,
    fullPath: string,
    filledPath: string
  ): number[] {
    console.log('Processing category:', {
      level,
      categoryName,
      fullPath,
      filledPath
    });

    // First, split the path and fill out all levels
    const levels = filledPath.split('/');
    const filledLevels = this.fillLevels(levels);
    
    // Then, calculate sort orders based on the filled levels
    const sortOrders = this.calculateSortOrders(filledLevels);

    console.log('Generated sort orders:', sortOrders);
    return sortOrders;
  }

  private fillLevels(levels: string[]): string[] {
    const filledLevels: string[] = new Array(5).fill('');
    
    // Fill in actual values first
    for (let i = 0; i < Math.min(levels.length, 5); i++) {
      if (levels[i]) {
        filledLevels[i] = levels[i];
      }
    }

    // Fill empty slots with the last non-empty value
    let lastValue = '';
    for (let i = 0; i < 5; i++) {
      if (filledLevels[i] !== '') {
        lastValue = filledLevels[i];
      } else if (lastValue !== '') {
        filledLevels[i] = lastValue;
      }
    }

    console.log('Filled levels:', filledLevels);
    return filledLevels;
  }

  private calculateSortOrders(filledLevels: string[]): number[] {
    const sortOrders: number[] = [];

    for (let i = 0; i < 5; i++) {
      const categoryAtLevel = filledLevels[i];
      
      if (!categoryAtLevel) {
        sortOrders[i] = 10000;
        continue;
      }

      // If this is the first time we're seeing this category at this level
      if (!this.seenCategories[i].has(categoryAtLevel)) {
        this.seenCategories[i].add(categoryAtLevel);
        this.categoryToSortOrder[i][categoryAtLevel] = this.nextSortOrder[i];
        console.log(`New category at level ${i}: "${categoryAtLevel}" -> ${this.nextSortOrder[i]}`);
        this.nextSortOrder[i] += 10;
      }

      sortOrders[i] = this.categoryToSortOrder[i][categoryAtLevel];
    }

    return sortOrders;
  }
}